"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldLoadXpPlanNames = exports.isCovidVaccineProvider = exports.getCovidShouldUseDefaultStepOrder = exports.getCovidPatientRegFormConfig = void 0;
var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _provider = require("./constants/provider");
/**
 * Looks for the covid patient_reg_form config in the PMCDB config object
 * @param {Object} config The PMCDB config object from CS
 * @returns {Object} The covid vaccine specific patient_reg_form
 * @returns {undefined} if a covid reg form config isn't found
 */
const getCovidPatientRegFormConfig = config => {
  return config.covid && config.covid.patient_reg_form;
};

/**
 * Determines if a provider is a covid vaccine provider, based on entity_type
 * @param {Object} provider Provider oject
 * @returns {Boolean} Whether or not the provider is a covid vaccine provider
 */
exports.getCovidPatientRegFormConfig = getCovidPatientRegFormConfig;
const isCovidVaccineProvider = provider => {
  if (provider[_provider.PROVIDER_TYPE]) {
    return provider[_provider.PROVIDER_TYPE] === _provider.COVID_VACCINE_PROVIDER_TYPE;
  }
  return false;
};
exports.isCovidVaccineProvider = isCovidVaccineProvider;
const getCovidShouldUseDefaultStepOrder = config => {
  return Boolean(config.covid && config.covid.use_default_step_order);
};

/**
 * Determines based on a given patient reg form config whether or not _xp_plan_names are required
 * @param {Object} regFormConfig Patient reg form configuration oject
 * @returns {Boolean} Whether or not the given reg form config requires _xp_plan_names
 */
exports.getCovidShouldUseDefaultStepOrder = getCovidShouldUseDefaultStepOrder;
const shouldLoadXpPlanNames = regFormConfig => {
  const {
    fields
  } = regFormConfig || {};
  return (0, _some.default)(fields).call(fields, field => {
    var _context;
    return field.path && (0, _includes.default)(_context = field.path).call(_context, 'plan_name') &&
    // forms-v2 fields without isVisible specified default to isVisible = true
    field.isVisible !== false;
  });
};
exports.shouldLoadXpPlanNames = shouldLoadXpPlanNames;